/**
 * TYT PDP zoom — full-screen "read the poster up close" popup for tyt-product-hero.
 *
 * Mirrors the customiser PDP zoom (apps.design.customiser.$productId.tsx):
 *   - Click the "Zoom" pill → dark full-screen overlay with the poster enlarged.
 *   - Click the poster → toggle fit-height ↔ fit-width (the bigger one scrolls).
 *   - Click the backdrop, or press Esc → close.
 *   - A tiled "TELL YOUR TRAIL" watermark discourages screenshot-for-print.
 *
 * The customiser enlarges a live SVG; the theme enlarges the current <img>. We
 * read whatever image is showing at open time (so it always reflects the
 * selected colour, even after tyt-variant-picker swaps the src) and request a
 * higher-resolution copy from the Shopify CDN by bumping the `width` param.
 *
 * Watermark: a static tiled "TELL YOUR TRAIL" mark set in CSS (.tyt-pdp-zoom-
 * watermark) reads on light posters (via its dark stroke) AND dark posters (via
 * its white fill). MID-TONES (e.g. teal) wash out both, so here we sample the
 * poster's brightness and, only for mid-tones, swap in a stronger-stroke tile.
 * Light + dark keep the CSS default; if sampling is blocked, so does everything.
 */
(function () {
  var ZOOM_WIDTH = 2400; // high-res copy requested for the enlarged view

  function hiRes(url, width) {
    if (!url) return url;
    try {
      var abs = url.indexOf('//') === 0 ? window.location.protocol + url : url;
      var u = new URL(abs, window.location.href);
      u.searchParams.set('width', String(width));
      return u.href;
    } catch (e) {
      return url;
    }
  }

  // Watermark tile with a stronger dark stroke — used only for mid-tone posters.
  // (The white fill stays 0.10, matching the CSS default, so dark posters that
  // happen to fall in the mid band don't get brighter.)
  function midToneWatermark() {
    var tile =
      "<svg xmlns='http://www.w3.org/2000/svg' width='280' height='160'>" +
      "<text x='60' y='92' font-family='monospace' font-size='16' letter-spacing='3' " +
      "fill='#FFFFFF' fill-opacity='0.07' stroke='#000000' stroke-opacity='0.15' " +
      "stroke-width='0.6' transform='rotate(-28 140 80)'>TELL YOUR TRAIL</text></svg>";
    return 'url("data:image/svg+xml,' + encodeURIComponent(tile) + '")';
  }

  function init(section) {
    var openBtn = section.querySelector('[data-tyt-zoom-open]');
    var overlay = section.querySelector('[data-tyt-zoom-overlay]');
    if (!openBtn || !overlay) return;

    var zoomPoster = overlay.querySelector('[data-tyt-zoom-poster]');
    var zoomImg = overlay.querySelector('[data-tyt-zoom-img]');
    var scroll = overlay.querySelector('[data-tyt-zoom-scroll]');
    var watermark = overlay.querySelector('.tyt-pdp-zoom-watermark');
    if (!zoomPoster || !zoomImg) return;

    function currentPosterSrc() {
      var img = section.querySelector('.tyt-pdp-gallery__poster img');
      if (!img) return null;
      return img.currentSrc || img.src;
    }

    // Mid-tone posters (e.g. teal) wash out the CSS default watermark, so sample
    // the poster's corner pixel and, only for mid-tones, swap in a stronger tile.
    // Light + dark keep the CSS default; a blocked canvas read keeps it too.
    function applyWatermark(src) {
      if (!watermark) return;
      watermark.style.backgroundImage = ''; // revert to the CSS default
      if (!src) return;
      var probe = new Image();
      probe.crossOrigin = 'anonymous';
      probe.onload = function () {
        try {
          var cv = document.createElement('canvas');
          cv.width = probe.naturalWidth || 1;
          cv.height = probe.naturalHeight || 1;
          var ctx = cv.getContext('2d');
          ctx.drawImage(probe, 0, 0);
          var d = ctx.getImageData(1, 1, 1, 1).data;
          var lum = (0.299 * d[0] + 0.587 * d[1] + 0.114 * d[2]) / 255;
          if (lum > 0.42 && lum < 0.82) {
            watermark.style.backgroundImage = midToneWatermark();
          }
        } catch (e) {
          /* canvas read blocked → keep the CSS default */
        }
      };
      probe.src = hiRes(src, 60); // small copy, just for sampling
    }

    // Two states: "fit" = whole poster visible; "zoom" = enlarged (scrolls).
    function setMode(mode) {
      zoomPoster.classList.toggle('is-fit', mode === 'fit');
      zoomPoster.classList.toggle('is-zoom', mode === 'zoom');
      if (scroll) {
        scroll.scrollTop = 0;
        scroll.scrollLeft = 0;
      }
    }

    function open() {
      var src = currentPosterSrc();
      if (!src) return;
      zoomImg.src = hiRes(src, ZOOM_WIDTH);
      applyWatermark(src);
      setMode('fit'); // every open starts on the whole-poster view
      overlay.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function close() {
      overlay.hidden = true;
      document.body.style.overflow = '';
    }

    openBtn.addEventListener('click', open);
    overlay.addEventListener('click', close);
    zoomPoster.addEventListener('click', function (e) {
      // Click the poster toggles zoom level; don't let it bubble to close.
      e.stopPropagation();
      setMode(zoomPoster.classList.contains('is-fit') ? 'zoom' : 'fit');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) close();
    });
  }

  function boot() {
    var sections = document.querySelectorAll('[data-tyt-pdp-zoom]');
    for (var i = 0; i < sections.length; i++) init(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
